
import { defineComponent } from 'vue';
import NavLinkComponent from './NavLinkComp.vue';

export default defineComponent({
    name: 'MobileNavComponent',
    components: {
        NavLinkComponent 
    },
});
